// Gameplay tuning. Change these to adjust how the game feels.

export const DEBUG = import.meta.env.VITE_DEBUG === "true";

// Physics (px/s and px/s²)
export const GRAVITY = 350;
export const TERMINAL_VELOCITY = 350;

// Controls
export const DOUBLE_TAP_THRESHOLD_MS = 280;

// Barriers
export const FIRST_SPAWN_DELAY_SEC = 0.8;
export const BARRIER_INITIAL_SPEED = 50;
export const BARRIER_MAX_SPEED = 250;
export const BARRIER_INITIAL_SPAWN_INTERVAL_SEC = 2;
export const BARRIER_MIN_SPAWN_INTERVAL_SEC = 1;

// Difficulty ramps with score
export const SPEED_GAIN_PER_POINT = 0.04;
export const SPAWN_INTERVAL_DROP_PER_POINT = 0.0003;
export const SECONDARY_COLORS_UNLOCK_SCORE = 400;

// Scoring
export const SURVIVAL_POINTS_PER_SEC = 10;
export const POINTS_PER_PASS = 100; // multiplied by the current combo
export const MAX_COMBO = 10;

export const DEATH_TRANSITION_DELAY_SEC = 0.85;
